import React from "react";
import "./CustomInput.scss";

export default function CustomInput({ id, floatingLabel, value, onChange, type = "text", placeholder = " ", className, disabled, icon: InputIcon, name }) {
  let classNameLocal = "customInputField";
  if (className) classNameLocal += ` ${className}`;
  if (floatingLabel) placeholder = " ";

  return (
    <div className={`customInputContainer ${InputIcon ? "withIcon" : ""} ${disabled ? "disabled" : ""}`}>
      {InputIcon && <span className="inputIcon">{InputIcon}</span>}
      <input
        name={name}
        className={classNameLocal}
        type={type}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      />
      {floatingLabel && (
        <label
          className={`floatingLabel ${InputIcon ? "withIcon" : ""}`}
          htmlFor={id}
        >
          {floatingLabel}
        </label>
      )}
    </div>
  );
}
